import React from "react";
import { ReactComponent as DollarIcon } from "@/assets/img/dollar_icon.svg";
import { ReactComponent as RielIcon } from "@/assets/img/riel_icon.svg";
import { ReactComponent as GoldICon } from "@/assets/img/gold_currency.svg";
import { numberFormatter } from "@/util/formatter";
import styles from "./styles.module.scss";

export default function CurrenciesCard({
  title,
  khrBalance,
  usdBalance,
  xauBalance,
  ...others
}) {
  return (
    <div className={styles.currenciesCard} {...others}>
      <h4 className={styles.title}>{title}</h4>
      <div className={styles.balance}>
        <RielIcon className={styles.rielIcon} />
        {numberFormatter(khrBalance, 0)}
      </div>
      <div className={styles.balance}>
        <DollarIcon className={styles.dollarIcon} />
        {numberFormatter(usdBalance, 2)}
      </div>
      <div className={styles.balance}>
        <GoldICon className={styles.goldIcon} />
        {numberFormatter(xauBalance, 2)}
      </div>
    </div>
  );
}
